<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("role.access.new") }}</span>
      </h2>

      <label>{{ $t("role.text") }}</label>
      <filter-select
        class=""
        id="accessFilter"
        ref="accessFilter"
        :placeholder="$t('role.text')"
        :multiple="false"
        @filter="onRoleSearch"
        :selected="form.role"
        @changed="onRoleSelect"
      />

      <label class="mt-3">{{ $t("role.access.accessable") }}</label>
      <filter-select
        id="accessFilter"
        ref="accessFilter"
        :placeholder="$t('role.text')"
        :multiple="true"
        @filter="onRoleSearch"
        :selected="form.access"
        @changed="onAccessSelect"
        :limit="3"
      />

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import sweetTextarea from "../../components/common/form/sweet-textarea.vue";

export default {
  components: { sweetTextarea },
  data() {
    return {
      form: { role: undefined, access: undefined },
      formError: undefined,
      selections: [],
      selectionMap: {},
      isSelectedAll: false,
    };
  },
  validations: {
    form: {
      role: {
        required,
      },
      access: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`managementRoleAccess/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`managementRoleAccess/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`managementRoleAccess/isEditMode`];
    },
  },
  mounted() {},

  methods: {
    async onRoleSearch(value, callback) {
      const response = await this.$store.dispatch(`managementRole/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onRoleSelect(item) {
      this.form.role = item;
    },
    onAccessSelect(item) {
      this.form.access = item;
    },

    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`managementRoleAccess/save`, {
          _id: this.form._id,
          role: this.form.role,
          access: this.form.access,
        });
        this.$root.$emit("bv::toggle::collapse", "sidebar-new");
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
